import React from 'react';

import ReactComponent from './weather-station-icon.svg?react';

export default function WeatherStationIcon() {
  return <ReactComponent />;
}
